<div class="row m-0 justify-content-center" style="padding-top: 25px;" *ngIf="isCheckIn && dato">
  <div class="col-12 pt-2 pr-0 container-items pl-0 m-0 align-items-stretch">
    <div class="d-flex container-item-card justify-content-between" style="border: 2px solid #c2c2c3; border-radius: 8px; gap: 25px;">

      <!-- Icon column -->
      <div class="d-flex align-items-center justify-content-center" style="width: 100%; max-width: 175px; background-color: #f1f1f1; border-top-left-radius: 6px; border-bottom-left-radius: 6px;">
        <img
          style="width: 60px; height: 60px; object-fit: contain;"
          src="../../../../assets/img/app/categories-search-box/AEREO.svg"
          alt="Vuelo"
        />
      </div>

      <div class="hotel-item-description px-0" style="width: calc(100% - 190px); padding-bottom: 10px;">
        <div class="d-flex- flex-column">
          <div class="d-flex justify-content-between align-items-start mb-3">
            <div class="mt-2" style="min-height: 48px;">
              <p
                class="tittle mb-1"
                style="max-width: 320px; font-family: &quot;Poppins&quot;; font-size: 18.5px; font-weight: 600; line-height: 1.3; margin-top: 5px !important"
              >
                {{ dato.title }} <span *ngIf="isRoundTrip()" style="font-size: 14px; font-weight: 400; color: #666;">(ida y vuelta)</span>
                <span *ngIf="getDirectionLabel()" style="font-size: 14px; font-weight: 400; color: #666;">({{ getDirectionLabel() }})</span>
              </p>
              <span *ngIf="dato.rateClassId === 'R'" class="px-2 py-1" style="font-size: 12px; font-family: 'Rubik'; font-weight: 400; color: #34c26d; background-color: #defef4; border-radius: 6px;">Reembolsable</span>
              <span *ngIf="dato.rateClassId && dato.rateClassId !== 'R'" class="px-2 py-1" style="font-size: 12px; font-family: 'Rubik'; font-weight: 400; color: #ed3b5b; background-color: #fde6ea; border-radius: 6px;">No Reembolsable</span>
            </div>
            <div class="d-flex">
              <div class="pt-2 pr-2" style="font-weight: 400;">
                <span *ngIf="dato.status_id === 1" class="status status-sidebar product-status-saved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 2" class="status status-sidebar product-status-reserved">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 3" class="status status-sidebar product-status-locked">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 4" class="status status-sidebar product-status-denied">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 5" class="status status-sidebar product-status-cancelled">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 6" class="status status-sidebar product-status-paid-agency">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 7" class="status status-sidebar product-status-paid-provider">{{ dato.status }}</span>
                <span *ngIf="dato.status_id === 8" class="status status-sidebar product-status-completed">{{ dato.status }}</span>
              </div>
              <div
                *ngIf="dato.status_id !== 5"
                class="d-flex align-items-end justify-content-center"
                style="border-bottom: 1px solid #ccc; border-left: 1px solid #ccc; border-bottom-left-radius: 6px; padding: 10px 15px; gap: 5px;"
              >
                <div style="width: 25px; height: 25px" *ngIf="dato.status_id === 1">
                  <img
                    style="margin-top: -4px; cursor: pointer"
                    tooltip="Eliminar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/summary/delete.svg"
                    alt=""
                  />
                </div>

                <div style="width: 25px; height: 25px" *ngIf="dato.status_id === 2">
                  <img
                    style="
                      margin-top: -4px;
                      cursor: pointer;
                      filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                    "
                    tooltip="Cancelar producto"
                    (click)="removeItem(dato)"
                    placement="bottom"
                    src="../../../../assets/icons/itinerary-detail/04-01.svg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-stretch">
          <!-- Ruta / Fechas -->
          <div class="d-flex flex-column justify-content-start pt-3" style="width: 30%; min-height: 62px">
            <div class="d-flex align-items-start" style="width: 100%">
              <img width="25px" height="25px" style="margin-top: -3px" src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
              <div class="d-flex flex-column">
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif !important; font-size: 14px; font-weight: 600; line-height: 1;">
                  {{ dato.origin }} - {{ dato.destinationAirport }}
                </p>
                <p class="mb-0 mt-1" style="font-family: &quot;Rubik&quot;, serif !important; font-size: 12px; font-weight: 500; line-height: 1.3; color: #666;">
                  {{ formatDate(dato.arrivalDate) }}
                  <span *ngIf="isRoundTrip()"> / {{ formatDate(dato.departureDate) }}</span>
                </p>
              </div>
            </div>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <!-- Pax -->
          <div class="d-flex justify-content-center pt-3" style="width: 38%;">
            <div class="d-flex flex-column">
              <div class="d-flex flex-column" style="gap: 2px;">
                <p
                  class="p-0 m-0 inter"
                  style="font-family: &quot;Rubik&quot;, serif !important; font-size: 13px; font-weight: 600; line-height: 1"
                >
                  {{ dato.adults }} Adultos&nbsp;-&nbsp;{{ dato.children }} Niños
                </p>
                <p
                  class="p-0 m-0 inter"
                  style="font-family: &quot;Rubik&quot;, serif !important; font-size: 13px; font-weight: 600; line-height: 1"
                >
                  {{ dato.providerName }}
                </p>
              </div>
            </div>
          </div>

          <!-- Line Vertical -->
          <div style="width: 1px; background-color: #ccc;"></div>

          <!-- Price -->
          <div class="d-flex flex-column pr-3" style="width: 32%; align-items: flex-end; min-height: 62px; margin-top: -8px;">
            <p
              class="title-destiny-start text-nowrap mb-0"
              [ngClass]="{ 'pr-3': dato.status_id !== 5 }"
              style="
                font-family: &quot;Rubik&quot;, serif !important;
                font-size: 14px !important;
                font-weight: 500 !important;
                line-height: 1.3;
                color: #666666;
              "
            >
              {{ currencyAgency?.code }}
            </p>
            <div class="d-flex align-items-center">
              <p
                class="title-destiny-start text-nowrap"
                style="color: #000000; font-family: &quot;Rubik&quot;, serif !important; font-weight: 600 !important; line-height: 1.3; font-size: 19.19px;"
              >
                <span *ngIf="dato.status_id !== 5">
                  {{ getPrice(dato) | number: "1.2-2" }}
                </span>
                <span *ngIf="dato.status_id === 5">
                  {{ 0 | number: "1.2-2" }}
                </span>
              </p>

              <ng-container *ngIf="dato.status_id !== 5">
                <usb-tooltip-convert-amount
                  [clientsSettingAppBooking]="clientSetting"
                  [currencyProduct]="currencyAgency?.code"
                  [valueProduct]="getPrice(dato)"
                >
                </usb-tooltip-convert-amount>
              </ng-container>
            </div>
            <div *ngIf="dato.status_id !== 5" class="d-flex flex-column justify-content-end align-items-end pb-1">
              <p
                class="mb-0"
                style="color: #b6b6b6;font-family: &quot;Rubik&quot;, serif !important; font-size: 12px; line-height: 1.3"
                [ngClass]="{ 'pr-3': dato.status_id !== 5 }"
              >
                Imp. Incl.
              </p>
              <div *ngIf="dato.currency !== currencyAgency?.code" class="d-flex justify-content-end">
                <p class="mb-0" style="font-family: &quot;Rubik&quot;, serif; font-size: 12px; font-weight: 600">
                  <span style="color: #616161">{{ dato.currency }}</span> {{ dato.netPriceAgent | number: "1.2-2" }}
                </p>
                <div class="info-tool d-flex flex-column position-relative">
                  <img src="../../../assets/icons/admi_01.svg" width="12px" alt="">
                  <span class="tooltip-info shadow-md">
                    <div class="d-flex justify-content-center align-items-center px-2 py-1">
                      <p class="mb-0" style="font-size: 14px; color: black">{{ userService.messageProviderAmount }}</p>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
